import { api } from '@/api';

const createScoringCategory = (scoringCategory) => {
  return api.post('/api/kyc/v1/admin/scoring/category', {
    ...scoringCategory
  });
};

const updateScoringCategory = (scoringCategory) => {
  return api.put('/api/kyc/v1/admin/scoring/category', {
    categoryScoringId: scoringCategory.id,
    ...scoringCategory
  });
};

const deleteScoringCategory = (scoringCategory) => {
  return api.delete('/api/kyc/v1/admin/scoring/category', {
    data: {
      categoryScoringId: scoringCategory.id
    }
  });
};

const addScoringCategoryToQuestionnaire = ({ questionSectionTypeId, categoryScoringId }) => {
  return api.post('/api/kyc/v1/admin/scoring/categoryWithQuestionSectionType', {
    questionSectionTypeId,
    categoryScoringId
  });
};
const deleteScoringCategoryFromQuestionnaire = ({ questionSectionTypeId, categoryScoringId }) => {
  return api.delete('/api/kyc/v1/admin/scoring/categoryWithQuestionSectionType', {
    questionSectionTypeId,
    categoryScoringId
  });
};

export const ScoringConstructorApi = {
  createScoringCategory,
  updateScoringCategory,
  deleteScoringCategory,
  addScoringCategoryToQuestionnaire,
  deleteScoringCategoryFromQuestionnaire
};
